import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';
import moment from 'moment';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getDeviceInfo, getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

const GameNamePanel: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { gameTitle: string }, newState: any) => ({ ...state, ...newState }), {
        gameTitle: ''
    });

    const globalStyles = useAppSelector(getGlobalStyles);
    const device = useAppSelector(getDeviceInfo);
    const classes = cn(styles.gameNamePanel_container, globalStyles.orientation);

    useEffect(() => {
        setState({ gameTitle: ConfigLoader.getConfiguration(EConfigurationNames.GAME).gameTitle });
    }, []);

    return <>{ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).gameNamePanel && <div className={classes}>{state.gameTitle}</div>}</>;
};

export default GameNamePanel;
